import { Quiz } from "./configuration/Quiz";

export class Cupom {
  is_Protocolo: number;
  is_Ressarcimento: number;
  is_Pln: number;
  nr_Protocolo: string;
  nr_Cupom: string;
  dt_Cupom: Date;
  dt_Vl_Cupom: Date;
  is_Status: number;
  status_Protocolo: string;
  dt_Utilizacao: Date;
  email: string;
  rede: string;
  nm_Cvp: string;
  qtd_Cupons: number = 1;
  cidade_Rede: string;
  uf_Rede: string;
  cnpj_Rede: string;
  produto: string;
  nsu: string;
  cupom_Fiscal: string;
  cpf: string;
  is_Rus: number;
  nr_cel: string;
  beneficiario_endereco: string;
  beneficiario_endereco_numero: string;
  beneficiario_endereco_complemento: string;
  beneficiario_endereco_bairro: string;
  beneficiario_endereco_cidade: string;
  beneficiario_pais: string;
  beneficiario_diabete: string;
  beneficiario_endereco_uf: string;
  beneficiario_tp_sexo: string;
  ean: string;
  nome_Produto: string;
  apresentacao: string;
  //checkVencido: boolean = this.status_Protocolo == 'Vencido' ? true : false;
}

export class CupomNovo {
  protocolo: number;
  qdtProtocolo: number;
  qtd_Cupons: number;
  nomeBeneficiario: string;
  genero: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  pais: string;
  tipoDiabete: string;
  beneficiario_aceite_contato: boolean;

  beneficiario_nome: string;
  beneficiario_cpf: string;
  beneficiario_endereco: string;
  beneficiario_endereco_cel: string;
  beneficiario_endereco_numero: string;
  beneficiario_endereco_complemento: string;
  beneficiario_endereco_bairro: string;
  beneficiario_endereco_cidade: string;
  beneficiario_endereco_cep: string;
  beneficiario_pais: string;
  beneficiario_diabete: string;
  beneficiario_endereco_uf: string;
  beneficiario_tp_sexo: string;
  beneficiario_email_1: string;
  beneficiario_dt_nascimento: string;

  produtos: any[];

  produtoo: ProdutoSelecionado[];
}

export class CupomBackend {
  is_Protocolo: number;
  is_Ressarcimento: number;
  is_Pln: number;
  nr_Protocolo: string;
  nr_Cupom: string;
  dt_Cupom: Date;
  dt_Vl_Cupom: Date;
  is_Status: number;
  status_Protocolo: string;
  dt_Utilizacao: Date;
  email: string;
  rede: string;
  nm_Cvp: string;
  qtd_Cupons: number = 1;
  cidade_Rede: string;
  uf_Rede: string;
  cnpj_Rede: string;
  produto: string;
  nsu: string;
  cupom_Fiscal: string;
  cpf: string;
  is_Rus: number;
  nr_cel: string;
  idsProdutos: string;
  produtos: ProdutoSelecionado[];
  ean: string;
  nome_Produto: string;
  apresentacao: string;
  nr_crm: string;
  uf_crm: string;
}

export class Beneficiary {
  Fields: Field[];
  Quiz: Quiz[];
}

export class Field {
  columnId: number;
  tableId: number;
  value: any;
}

export class ProdutoSelecionado {
  value: number;
  label: string;
}

